// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"11":"9108bf69","72":"7e5ad08b","196":"7dea4b2f","431":"00f5b7a5","577":"d32e1318","604":"9a3cd0a0","710":"515fe1d6","760":"deda95b7","808":"0338be7f","969":"22d83df1"}[chunkId] + ".js";
};